import React from "react";
import { withSnackbar } from "notistack";
import ReactGA from "react-ga4";
import {
  Avatar,
  Button,
  Box,
  IconButton,
  InputAdornment,
  CardMedia,
  Typography,
  colors,
  TextField,
  Grid,
  Checkbox,
  Collapse,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { appService } from "../App/app.service";
import * as Yup from "yup";
import { Formik } from "formik";
import Logo from "../components/Logo";
import ViewIcon from "@material-ui/icons/Visibility";
import OffIcon from "@material-ui/icons/VisibilityOff";
import { withRouter } from "react-router-dom";
import {
  passwordValidation,
  passwordValidationLabel,
} from "../Settings/AccountSettings/password-validaton";
import ResetPasswordFormikComponent from "../App/ResetPasswordFormikComponent";
import LoginForm from "./LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ChangePasswordForm from "./ChangePasswordForm";
import AuthTemplate from "./AuthTemplate";
import MFAForm from "./MFAForm";
import IframeContent from "./IframeContent";

const viz_url = process.env.REACT_APP_VIZ_URL;

const styles = (theme) => ({
  root: {
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    overflow: "auto",
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      margin: 0,
      width: "100vw",
      maxWidth: "100vw",
      height: "auto",
      minHeight: "100vh",
      overflow: "auto",
    },
  },
  container: {
    minHeight: "100vh",
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      margin: "0 !important",
      width: "100vw !important",
      maxWidth: "100vw !important",
      padding: "0 !important",
    },
  },
  innerContainer: {
    minHeight: "100%",
    width: "100%",
    flex: 1,
    padding: theme.spacing(4, 2),
    paddingBottom:theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      margin: "0 !important",
      width: "100% !important",
      height: "auto",
      flex: "none",
      padding: theme.spacing(1),
    },
  },
  formWrapper: {
    width: "100%",
    maxWidth: "600px",
    display: "flex",
    justifyContent: "center",
    flex: "0 0 auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      padding: "0 !important",
    },
  },
  leftContainer: {
    backgroundColor: "#f5f5f5",
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      order: 2,
      minHeight: "auto",
      padding: 0,
      backgroundColor: "#FFFFFF",
      width: "100%",
      height: "auto",
      overflow: "visible",
      flexBasis: "100%",
      maxWidth: "100%",
    },
    // iPad Pro / md breakpoint: full width in portrait, half in landscape
    [theme.breakpoints.only("md")]: {
      flexBasis: "100%",
      maxWidth: "100%",
      "@media (orientation: landscape)": {
        flexBasis: "50%",
        maxWidth: "50%",
      },
    },
  },
  rightContainer: {
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    overflow: "hidden",
    // Mobile (xs): hide completely (both portrait and landscape)
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    // Tablet (sm): hide completely (both portrait and landscape)
    [theme.breakpoints.only("sm")]: {
      display: "none",
    },
    // iPad Pro / md breakpoint: hide in portrait, show only in landscape
    [theme.breakpoints.only("md")]: {
      display: "none",
      "@media (orientation: landscape)": {
        display: "block",
        minHeight: "100vh",
      },
    },
  },
  formContainer: {
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      boxShadow: "none",
      padding: theme.spacing(2),
      borderRadius: 0,
    },
  },
  errorMessageStyle: {
    textAlign: "left",
    paddingTop: "10px",
    color: "red",
  },
  formStyle: {
    padding: "4%",
    paddingTop: "0%",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    }
  },
  rememberMeCheck: {
    padding: 0,
    marginRight: 10,
  },
  backButtonContainer: {
    textAlign: "left",
  },
  backButton: {
    textTransform: "none",
    padding: "0%",
    textAlign: "left",
    color: "#1565C0",
    justifyContent: "flex-start",
  },
  bottomContainer: {
    backgroundColor: "#FFFFFF",
    borderTop: "1px solid #e0e0e0",
    padding: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      order: 3,
    },
  },
  seeActionButton: {
    textTransform: "none",
    color: "#1565C0",
    fontSize: "0.875rem",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },
  actionSection: {
    marginTop: theme.spacing(3),
    width: "100%",
    flex: "0 0 auto",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  copyrightSection: {
     paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    width: "100%",
    flex: "0 0 auto",
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  learnMoreButton: {
    position: "absolute",
    bottom: theme.spacing(4),
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#FFFFFF",
    padding: theme.spacing(1.5, 3),
    borderRadius: "4px",
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    zIndex: 10,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: theme.spacing(2),
      left: theme.spacing(1.5),
      transform: "none",
      padding: theme.spacing(0.75, 1.5),
      fontSize: "0.625rem",
      minWidth: "auto",
      borderRadius: "2px",
    },
  },
});

const DEFAULT_LOGIN_PAGE_CONFIG = {
  desktopImageUrl:
    "https://skygeniwebapp.blob.core.windows.net/login-templates/Login_Desktop_RHS.webp",
  tabletImageUrl:
    "https://skygeniwebapp.blob.core.windows.net/login-templates/Login_Tablet_RHS.webp",
  mobileImageUrl:
    "https://skygeniwebapp.blob.core.windows.net/login-templates/Login_Mobile_RHS.webp",
  learnMoreUrl: "https://www.skygeni.com/white-space-conversion",
};

const getConfiguredValue = (value, fallbackValue) =>
  typeof value === "string" && value.trim() !== "" ? value : fallbackValue;

const normalizeLoginPageConfig = (config = {}) => ({
  desktopImageUrl: getConfiguredValue(
    config.desktopImageUrl,
    DEFAULT_LOGIN_PAGE_CONFIG.desktopImageUrl
  ),
  tabletImageUrl: getConfiguredValue(
    config.tabletImageUrl,
    DEFAULT_LOGIN_PAGE_CONFIG.tabletImageUrl
  ),
  mobileImageUrl: getConfiguredValue(
    config.mobileImageUrl,
    DEFAULT_LOGIN_PAGE_CONFIG.mobileImageUrl
  ),
  learnMoreUrl: getConfiguredValue(
    config.learnMoreUrl,
    DEFAULT_LOGIN_PAGE_CONFIG.learnMoreUrl
  ),
});

class LoginView extends React.Component {
  state = {
    location: "login",
    forgotPassEmail: "",
    errorMessage: this.props.alert.returnCode ? this.props.alert.message : "",
    open: true,
    loginEmail: "",
    loginPageConfig: DEFAULT_LOGIN_PAGE_CONFIG,
    loginPageConfigLoading: true,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.loggedIn) {
      const redirectTo = localStorage.getItem("redirectAfterLogin");
      // console.log(redirectTo, 'XYZZZZZ')
      if (redirectTo) {
        localStorage.removeItem("redirectAfterLogin");
        this.props.history.push(redirectTo);
      } else {
        this.props.history.push("/");
      }
    }
    if (prevProps.mfaLoginNeeded === false && this.props.mfaLoginNeeded === true) {
      this.setState({
        ...this.state,
        location: "mfaLogin"
      })
    }
    if (
      prevProps.forgotPasswordSuccess === false &&
      this.props.forgotPasswordSuccess === true
    ) {
      this.setState({
        ...this.state,
        location: "changePass",
      });
    }
    if (prevProps.forgotPassToken === "" && this.props.forgotPassToken !== "") {
      if (this.state.location === "forgotPass") {
        this.setState({
          ...this.state,
          location: "changePass",
        });
      }
    }
    if (
      this.props.alert !== "" &&
      this.props.alert.message ===
      "Password changed. Please sign in with new password."
    ) {
      if (this.state.location === "changePass") {
        this.setState({
          ...this.state,
          location: "login",
          forgotPassEmail: "",
        });
      }
    }

    if (this.props.alert.id !== prevProps.alert.id) {
      console.log(this.props.alert);
      /*
      For error code 600 // inactivity timeout happens only to alrady logged in users
1) Logout user
2) Show message as toast
      For error code 601 // Unknown company happens when trying to
1) Show message as box with close button
For error code 602 // Missing user, known company
1) Show message as box with close button
For error code 603 // Inactive, known user
1) Show message as box with close button
      */
      if (
        this.props.alert.returnCode == 604 ||
        this.props.alert.returnCode == 603 ||
        this.props.alert.returnCode == 601 ||
        this.props.alert.returnCode == 602 ||
        this.props.alert.returnCode == 600 ||
        this.props.alert.returnCode == 605 ||
        this.props.alert.returnCode == 999
      ) {
        console.log(this.props.alert.returnCode);
        this.setState({
          ...this.state,
          open: true,
          errorMessage: this.props.alert.message,
        });
      } else if (this.props.alert.returnCode) {
        console.log(this.props.alert.returnCode);
        this.props.enqueueSnackbar(
          this.props.alert.message || "Something went wrong",
          {
            variant: this.props.alert.type || "error",
          }
        );
      }
    }
    if (this.props.persistentAlert !== "" && prevProps.persistentAlert === "") {
      this.persistentAlert = this.props.enqueueSnackbar(
        this.props.persistentAlert.message,
        {
          variant: this.props.persistentAlert.type,
          persist: true,
        }
      );
    }
  };

  handleChangeLocation = (location) => {
    if (location === "login") {
      this.setState({
        ...this.state,
        location: "login",
        forgotPassEmail: "",
        errorMessage: "",
        open: true,
      });
      return;
    }
    this.setState({ ...this.state, location: location, errorMessage: "" });
  };

  loadLoginPageConfig = () => {
    appService.getLoginPageConfig().then(
      (response) => {
        this.setState({
          loginPageConfig: normalizeLoginPageConfig(response?.data),
          loginPageConfigLoading: false,
        });
      },
      () => {
        this.setState({
          loginPageConfig: DEFAULT_LOGIN_PAGE_CONFIG,
          loginPageConfigLoading: false,
        });
      }
    );
  };

  componentDidMount = () => {
    if (this.props.loggedIn) {
      const redirectTo = localStorage.getItem("redirectAfterLogin");
      console.log(redirectTo, "XYZZZZZ");
      if (redirectTo) {
        localStorage.removeItem("redirectAfterLogin");
        this.props.history.push(redirectTo);
      } else {
        this.props.history.push("/");
      }
      return;
    }

    this.loadLoginPageConfig();
  };
  onLoginSubmit = (values) => {
    this.setState({
      ...this.state,
      errorMessage: "",
      open: false,
      loginEmail: values.email,
    });
    this.props.login(values.email, values.password, values.checked);
  };
  onLoginSubmitWithRecaptcha = (values) => {
    this.setState({
      ...this.state,
      errorMessage: "",
      open: false,
    });
    this.props.loginWithRecaptcha(values.email, values.password, values.checked, values.token);
  };
  render() {
    const { classes } = this.props;
    const { location, errorMessage, open, loginPageConfig, loginPageConfigLoading } = this.state;
    return (
      <div className={classes.root}>
        <Grid
          container
          className={classes.container}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.leftContainer}
          >
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              wrap="nowrap"
              className={classes.innerContainer}
            >
              <Grid item className={classes.formWrapper}>
                <Box className={classes.formContainer}>
                  {location === "login" && (
                    <AuthTemplate childrenStyle={{}}>
                      <Grid item>
                        <LoginForm
                          onSubmit={this.onLoginSubmit}
                          onSubmitWithRecaptcha={this.onLoginSubmitWithRecaptcha}
                          classes={classes}
                          errorMessage={errorMessage}
                          open={open}
                          setErrorMessage={(msg) =>
                            this.setState({ errorMessage: msg, open: false })
                          }
                          persistentAlert={this.props.persistentAlert}
                          handleChangeLocation={this.handleChangeLocation}
                        />
                      </Grid>
                    </AuthTemplate>
                  )}
                  {
                    location === "mfaLogin" && (
                      <AuthTemplate
                        title="Multi Factor Authentication"
                        subtitle="Enter the 6-digit code that we sent to your email address."
                        childrenStyle={{}}>
                        <Grid item>
                          <MFAForm
                            onSubmit={(values) => {
                              this.props.mfaLogin(this.state.loginEmail, values.code);
                            }}
                            classes={classes}
                            errorMessage={errorMessage}
                            open={open}
                            handleChangeLocation={this.handleChangeLocation}
                            setErrorMessage={(msg) =>
                              this.setState({ errorMessage: msg, open: false })
                            }
                          />
                        </Grid>
                      </AuthTemplate>
                    )
                  }
                  {location === "forgotPass" && (
                    <AuthTemplate
                      title="Forgot Password"
                      subtitle="Enter your email and we'll send you a code to reset your password."
                      childrenStyle={{}}
                    >
                      <ForgotPasswordForm
                        onSubmit={(values) => {
                          this.setState({
                            ...this.state,
                            forgotPassEmail: values.email,
                            open: true,
                          });
                          this.props.forgotPass(values.email);
                        }}
                        classes={classes}
                        errorMessage={errorMessage}
                        open={open}
                        handleChangeLocation={this.handleChangeLocation}
                        setErrorMessage={(msg) =>
                          this.setState({ errorMessage: msg, open: false })
                        }
                      />
                    </AuthTemplate>
                  )}
                  {location === "changePass" && (
                    <AuthTemplate
                      title="Reset Password"
                      subtitle="Enter the code we sent to your email and create a new password."
                      childrenStyle={{ paddingTop: "1rem" }}>
                      <ChangePasswordForm
                        forgotPassEmail={this.state.forgotPassEmail}
                        changePass={this.props.changePass}
                        errorMessage={errorMessage}
                        open={open}
                        setState={(state) => this.setState(state)}
                        persistentAlert={this.persistentAlert}
                        forgotPass={this.props.forgotPass}
                        classes={classes}
                        alert={this.props.alert}
                        changePasswordSuccess={this.props.changePasswordSuccess}
                        forgotPasswordSuccess={this.props.forgotPasswordSuccess}
                        resetCodeExpired={this.props.resetCodeExpired}
                        resendLockoutSeconds={this.props.resendLockoutSeconds}
                        handleChangeLocation={this.handleChangeLocation}
                      />
                    </AuthTemplate>
                  )}
                </Box>
              </Grid>
              {location === "login" && (
                <Grid item className={classes.actionSection}>
                  <Box textAlign="center" display="flex" alignItems="center" justifyContent="center" style={{ gap: "16px" }}>
                    <Typography variant="body2" style={{ color: "#666", fontSize: "0.875rem" }}>
                      Not a customer?
                    </Typography>
                    <Button
                      variant="outlined"
                      onClick={() => window.open("https://www.skygeni.com/contact-us", "_blank")}
                      style={{
                        padding: '0.5rem 1rem',
                        color: "#1565C0",
                        textTransform: "none",
                        minWidth: "auto",
                        fontSize: "0.875rem",
                      }}
                    >
                      See SkyGeni in action
                    </Button>
                  </Box>
                </Grid>
              )}
              <Grid item className={classes.copyrightSection}>
                <Box textAlign="center">
                  <Typography variant="body2" style={{ color: "#999", fontSize: "0.75rem" }}>
                    © {new Date().getFullYear()} SkyGeni. All rights reserved.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.rightContainer}
          >
            <IframeContent
              imageUrls={loginPageConfig}
              isConfigLoading={loginPageConfigLoading}
            />
            <Button
              className={classes.learnMoreButton}
              onClick={() => window.open(loginPageConfig.learnMoreUrl, "_blank")}
            >
              Learn more
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    alert,
    persistentAlert,
    forgotPassToken,
    checked,
    loggedIn,
    changePasswordSuccess,
    forgotPasswordSuccess,
    mfaLoginNeeded,
    resetCodeExpired,
    resendLockoutSeconds,
  } = state.app;

  return {
    alert,
    persistentAlert,
    forgotPassToken,
    checked,
    loggedIn,
    changePasswordSuccess,
    forgotPasswordSuccess,
    mfaLoginNeeded,
    resetCodeExpired,
    resendLockoutSeconds,
  };
}

const mapDispatchToProps = (dispatch) => ({
  mfaLogin: (email, code) => {
    dispatch({ type: "mfa_login_request", email, code });
    appService.validateCode(email, code).then(
      (json) => {
        dispatch({ type: "mfa_login_success", json });
      },
      (error) => {
        console.log(error, "mfa_validation_error");
        if (error.isLoggedIn === false) {
          dispatch({ type: "udpating_app" });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (typeof error === "object") {
          dispatch({ type: "mfa_login_failure", error });
        } else {
          dispatch({ type: "mfa_login_failure", error });
        }
      }
    );
  },
  login: (username, password, checked) => {
    dispatch({ type: "login_request", username });
    appService.login(username, password).then(
      (json) => {
        if (checked) {
          localStorage.setItem(
            "skygeni-user-checked",
            JSON.stringify(username)
          );
          dispatch({ type: "add_checked", username });
          // console.log('GA_LOGIN_SUCCESS_DEBUG', json.message.UserID)
          // ReactGA.gtag("set", "user_properties", { user_id: json.message.UserID });
        } else {
          localStorage.removeItem("skygeni-user-checked");
          dispatch({ type: "remove_checked" });
        }
        // Set GA user ID on login (skip if missing — avoids throw before login_success)
        if (json.message?.UserID != null) {
          ReactGA.gtag("set", { user_id: json.message.UserID });
        }
        dispatch({ type: "login_success", json });
      },
      (error) => {
        console.log(error, "updating_app_error");
        if (error.isLoggedIn === false) {
          dispatch({ type: "udpating_app" });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (typeof error === "object")
          dispatch({ type: "login_failure", error });
        else dispatch({ type: "login_failure", error });
      }
    );
  },
  loginWithRecaptcha: (username, password, checked, token) => {
    dispatch({ type: "login_request", username });
    appService.loginWithRecaptcha(username, password, token).then(
      (json) => {
        if (checked) {
          localStorage.setItem(
            "skygeni-user-checked",
            JSON.stringify(username)
          );
          dispatch({ type: "add_checked", username });
        } else {
          localStorage.removeItem("skygeni-user-checked");
          dispatch({ type: "remove_checked" });
        }
        // Set GA user ID on login (skip if missing — avoids throw before login_success)
        if (json.message?.UserID != null) {
          ReactGA.gtag("set", { user_id: json.message.UserID });
        }
        dispatch({ type: "login_success", json });
      },
      (error) => {
        console.log(error, "updating_app_error");
        if (error.isLoggedIn === false) {
          dispatch({ type: "udpating_app" });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (typeof error === "object")
          dispatch({ type: "login_failure", error });
        else dispatch({ type: "login_failure", error });
      }
    );
  },
  forgotPass: (username) => {
    dispatch({ type: "forgot_pass_request", username });
    appService.forgotPass(username).then(
      (json) => {
        dispatch({ type: "forgot_pass_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "forgot_pass_failure",
            error,
          });
        else dispatch({ type: "forgot_pass_failure", error });
      }
    );
  },
  changePass: (code, password, token, email) => {
    dispatch({ type: "change_pass_request" });
    appService.changePass(code, password, token, email).then(
      (json) => {
        dispatch({ type: "change_pass_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "change_pass_failure",
            error,
          });
        else dispatch({ type: "change_pass_failure", error });
      }
    );
  },
});

const connectedLoginView = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles)(withSnackbar(LoginView))));
export { connectedLoginView as LoginView };
